import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private cache: Map<string, unknown> = new Map();

  put(url: string, response: unknown) {
    this.cache.set(url, response);
  }

  get(url: string): unknown {
    return this.cache.get(url);
  }

  clearByKey(url: string) {
    this.cache.delete(url);
  }

  clearAll() {
    this.cache.clear();
  }
}
